import React from 'react';
import {Text, TouchableOpacity} from 'react-native';

import { CopyToClipboard } from '../../commons/copyToClipBoard';

export const OrderNumberCell = ({
  value,
  item,
  redirectToProductDetail,
  redirectToScanPack
}) => {
  const handlePress = event => {
    const isCtrlPressed =
      event?.ctrlKey ||
      event?.metaKey ||
      event?.nativeEvent?.ctrlKey ||
      event?.nativeEvent?.metaKey;

    if (isCtrlPressed) {
      redirectToScanPack(item);
    } else {
      redirectToProductDetail(item, false);
    }
  };

  return (
    <TouchableOpacity
      style={{flexDirection: 'row', alignItems: 'center'}}
      testID="redirectToProductDetail"
      onPress={handlePress}>
      <Text style={[{color: '#aad9fc'}]} numberOfLines={1}>
        {value}
      </Text>
      <CopyToClipboard value={value} />
    </TouchableOpacity>
  );
};
